import safeFetch from '../../utils/safeFetch';

const getDeliveryDateFromUrl = (url, data) => {
  return new Promise((resolve, reject) => {
    safeFetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((htmlContent) => {
        resolve(htmlContent);
      })
      .catch((error) => reject(error));
  });
};

export default getDeliveryDateFromUrl;
